import { render, staticRenderFns } from "./BillingReference.vue?vue&type=template&id=b94be6e4&scoped=true"
import script from "./BillingReference.vue?vue&type=script&lang=js"
export * from "./BillingReference.vue?vue&type=script&lang=js"
import style0 from "./BillingReference.vue?vue&type=style&index=0&id=b94be6e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b94be6e4",
  null
  
)

export default component.exports